import vars from '../scripts/variables';

class LazyLoad {
    constructor() {
//        this.initLazyLoad();
//
//        const oldOpen = XMLHttpRequest.prototype.open;
//        XMLHttpRequest.prototype.open = function (...args) {
//            this.addEventListener('readystatechange', () => vars.lazyLoad.onXHRComplete(this));
//            oldOpen.apply(this, args);
//        };
    }

    onXHRComplete(xhr) {
        if (xhr.readyState >= 4) {
           // setTimeout(() => this.lazyLoadImges(), 0);
        }
    }

    initLazyLoad() {
        /*
        const that = this;
        const oldOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (...args) {
            that.lazyLoadImges();
            oldOpen.apply(this, args);
        };
        window.addEventListener('scroll', () => this.lazyLoadImges(), {
            passive: true
        });

        const thumbs = document.querySelector('#product_gallery_thumbs');
        if (thumbs) {
            thumbs.addEventListener('scroll', () => this.lazyLoadImges(), {
                passive: true
            });
        }

        this.lazyLoadImges();
        */
    }

    lazyLoadImges() {
        /*
        const images = document.querySelectorAll('img[data-src]:not(.no-lazy)');
        const offset = 300;
        for (const image of images) {
            const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
            const top = image.getBoundingClientRect().top + scrollTop;
            if (top > scrollTop - offset && top < scrollTop + window.innerHeight + offset && image.offsetParent !== null) {
                const src = image.getAttribute('data-src');
                image.removeAttribute('data-src');
                image.classList.add('loading');
                image.addEventListener('load', function () {
                    this.classList.add('lazy-loaded');
                    this.classList.remove('loading');
                });
                image.src = src;
            }
        }

        for (const image of document.querySelectorAll('img[src]:not(.loading):not(.lazy-loaded):not(.no-lazy)')) {
            image.classList.add('lazy-loaded');
        }
         */
    }

}

vars.lazyLoad = new LazyLoad();

export default vars.lazyLoad;
